<template>
  <div v-if="birthdayClients.length > 0" class="birthday-banner">
    <md-card class="birthday-card">
      <md-card-header class="md-card-header-icon md-card-header-success">
        <div class="card-icon">
          <md-icon>cake</md-icon>
        </div>
        <h4 class="title">
          <md-icon class="text-warning">celebration</md-icon>
          {{ $t('birthdayClientsToday') }}
        </h4>
        <p class="category">{{ birthdayClients.length }} {{ $t('clientsCelebrating') }}</p>
      </md-card-header>
      
      <md-card-content>
        <div class="birthday-clients-list">
          <div 
            v-for="client in birthdayClients" 
            :key="client._id" 
            class="birthday-client-item"
          >
            <div class="client-avatar">
              <img 
                v-if="client.avatar" 
                :src="client.avatar" 
                :alt="client.name"
                class="avatar-img"
              />
              <div v-else class="avatar-placeholder">
                <md-icon>person</md-icon>
              </div>
            </div>
            
            <div class="client-info">
              <h5 class="client-name">{{ client.name }}</h5>
              <p class="client-details">
                <md-icon class="small-icon">email</md-icon>
                {{ client.email }}
              </p>
              <p v-if="client.phone" class="client-details">
                <md-icon class="small-icon">phone</md-icon>
                {{ client.phone }}
              </p>
            </div>
            
            <div class="birthday-badge">
              <md-icon class="celebration-icon">celebration</md-icon>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { wencesApi } from '@/api/wencesApi';

export default {
  name: 'BirthdayBanner',
  data() {
    return {
      birthdayClients: [],
      loading: false
    };
  },
  async created() {
    await this.fetchBirthdayClients();
  },
  methods: {
    async fetchBirthdayClients() {
      try {
        this.loading = true;
        const response = await wencesApi.get('/api/users/birthday-clients');
        
        if (response.data.success) {
          this.birthdayClients = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching birthday clients:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.birthday-banner {
  margin-bottom: 20px;
}

.birthday-card {
  background: linear-gradient(135deg, #ff6b6b, #ffa726);
  color: white;
  box-shadow: 0 4px 20px rgba(255, 107, 107, 0.3);
  border-radius: 12px;
  overflow: hidden;
}

.birthday-card .md-card-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.birthday-card .title {
  color: white !important;
  font-weight: bold;
  margin: 0;
}

.birthday-card .category {
  color: rgba(255, 255, 255, 0.9) !important;
  margin: 5px 0 0 0;
}

.birthday-clients-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.birthday-client-item {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  padding: 15px;
  border-radius: 8px;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
}

.birthday-client-item:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.client-avatar {
  margin-right: 15px;
  flex-shrink: 0;
}

.avatar-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255, 255, 255, 0.3);
}

.avatar-placeholder {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgba(255, 255, 255, 0.3);
}

.avatar-placeholder .md-icon {
  color: white;
  font-size: 24px;
}

.client-info {
  flex: 1;
}

.client-name {
  color: white;
  font-weight: bold;
  margin: 0 0 5px 0;
  font-size: 16px;
}

.client-details {
  color: rgba(255, 255, 255, 0.8);
  margin: 2px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.small-icon {
  font-size: 16px !important;
  margin-right: 5px;
}

.birthday-badge {
  flex-shrink: 0;
  margin-left: 15px;
}

.celebration-icon {
  color: #ffeb3b;
  font-size: 32px !important;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .birthday-client-item {
    flex-direction: column;
    text-align: center;
  }
  
  .client-avatar {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .birthday-badge {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
